export default __webpack_public_path__ + "static/media/fruits_pears.6a132f57.jfif";